import ChannelGroupType from '@avtechsoftware/ra-javascript-utilities/src/types/ChannelGroupType';
import ChannelType from '@avtechsoftware/ra-javascript-utilities/src/types/ChannelType';
import ThreeReadingCard from '../cards/ThreeReadingCard';
import FourReadingCard from '../cards/FourReadingCard';
import TwoReadingCard from '../cards/TwoReadingCard';
import SingleReadingCard from '../cards/SingleReadingCard';
import { parseChannelKey } from '../../../../../../utility/channelUtils';

// todo: can refactor into specific channelGroup types
//  to reuse same pattern for different readingCards
export const CHANNEL_TYPE_ORDER = {
  [ChannelType.TEMPERATURE.id]: 1,
  [ChannelType.HUMIDITY.id]: 2,
  [ChannelType.DEW_POINT.id]: 3,
  [ChannelType.HEAT_INDEX.id]: 4,
};

const channelGroupTypeToComponentMap = {
  [ChannelGroupType.TEMPERATURE.id]: SingleReadingCard,
  [ChannelGroupType.TEMP_HUMIDITY.id]: FourReadingCard,
  [ChannelGroupType.TEMP_ANALOG.id]: ThreeReadingCard,
  [ChannelGroupType.TEMP_ACTIVE_POWER.id]: TwoReadingCard,
  [ChannelGroupType.EXTREME_TEMP.id]: TwoReadingCard,
  [ChannelGroupType.INTERNAL_ANALOG.id]: TwoReadingCard,
  [ChannelGroupType.SWITCH.id]: SingleReadingCard,
  [ChannelGroupType.INTERNAL_POWER.id]: SingleReadingCard,
  [ChannelGroupType.DEVICE.id]: SingleReadingCard,
  [ChannelGroupType.WIFI.id]: SingleReadingCard,
  [ChannelGroupType.TEMP_AIR_FLOW.id]: TwoReadingCard,
  [ChannelGroupType.PARTICULATE_TEMP.id]: ThreeReadingCard,
  [ChannelGroupType.APP_CONNECTOR_CONNECTION.id]: SingleReadingCard,
  [ChannelGroupType.HTTP_PING.id]: ThreeReadingCard,
  [ChannelGroupType.ICMP_PING.id]: TwoReadingCard,
  [ChannelGroupType.MOTION.id]: SingleReadingCard,
  [ChannelGroupType.THRESHOLD_RANGE.id]: TwoReadingCard,
  [ChannelGroupType.BLUETOOTH_LE.id]: ThreeReadingCard,
  [ChannelGroupType.SCS_FAN_CTRL_META_DATA.id]: ThreeReadingCard,
  [ChannelGroupType.SCS_FAN_CTRL_GROUP.id]: FourReadingCard,
  [ChannelGroupType.SCS_ALARM.id]: SingleReadingCard,
  [ChannelGroupType.COMPUTED_SENSOR.id]: FourReadingCard,
  UNKNOWN: null,
};

// eslint-disable-next-line import/prefer-default-export
export const getReadingCardComponent = (channelGroup) => {
  const { channelKey, channels } = channelGroup;
  const { channelGroupType } = parseChannelKey(channelKey);

  const filteredChannels = channels.filter((channel) => {
    const { channelType } = parseChannelKey(channel.channelKey);
    return channelType !== ChannelType.UNKNOWN.id
        && channelType !== ChannelType.PUSH_STATUS.id && channelType !== ChannelType.ALARM.id;
  });

  const filteredChannelCount = filteredChannels.length;

  if (channelGroupType === ChannelGroupType.INTERNAL_ANALOG.id) {
    if (filteredChannelCount === 2) {
      return TwoReadingCard;
    }
    return SingleReadingCard;
  }

  if (channelGroupType === ChannelGroupType.TEMP_ANALOG.id) {
    const hasAnalogConversion = channels.some((channel) => {
      const { channelType } = parseChannelKey(channel.channelKey);
      return channelType === ChannelType.VOLTAGE.id && channel.conversion.type !== 0;
    });
    if (hasAnalogConversion) {
      if (filteredChannelCount === 3) {
        return ThreeReadingCard;
      }
    }
    return TwoReadingCard;
  }

  if (channelGroupType === ChannelGroupType.TEMP_AIR_FLOW.id) {
    const hasAirFlowConversion = channels.some((channel) => {
      const { channelType } = parseChannelKey(channel.channelKey);
      // return channelType === ChannelType.SPEED.id && channel.conversion.type !== 0;
      return channelType === ChannelType.FLOW.id;
    });
    if (hasAirFlowConversion) {
      if (filteredChannelCount === 3) {
        return ThreeReadingCard;
      }
    }
    return TwoReadingCard;
  }

  if (channelGroupType === ChannelGroupType.EXTREME_TEMP.id) {
    const faultChannel = channels.find((channel) => {
      const { channelType } = parseChannelKey(channel.channelKey);
      return channelType === ChannelType.EXTREME_TEMPERATURE_FAULT.id;
    });
    if (faultChannel && faultChannel.value > 0) {
      return ThreeReadingCard;
    }
    return TwoReadingCard;
  }

  if (channelGroupType === ChannelGroupType.PARTICULATE_TEMP.id) {
    const faultChannel = channels.find((channel) => {
      const { channelType } = parseChannelKey(channel.channelKey);
      return channelType === ChannelType.PARTICULATE_TEMP_FAULT.id;
    });
    if (faultChannel && faultChannel.value > 0) {
      return FourReadingCard;
    }
    return ThreeReadingCard;
  }

  return channelGroupTypeToComponentMap[channelGroupType] || null;
};
